import React, { memo, Fragment } from 'react'
import { NavLink } from 'react-router-dom'
import propTypes from 'prop-types'
import Logo from './Logo'

const Nav = ({ authUser, handleLogoutUser, isAuthenticated }) => (
  <header className="header">
    <nav>
      <div className="pullLeft">
        <NavLink to="/" className="navLink logo">
          <Logo />
        </NavLink>
        {isAuthenticated && (
          <NavLink to="/deshboard" className="navLink">
            Deshboard
          </NavLink>
        )}
      </div>
      <div className="pullRight">
        {(isAuthenticated && (
          <Fragment>
            <div className="userName">{authUser.email}</div>
            <button className="navLink" onClick={handleLogoutUser}>
              Logout
            </button>
          </Fragment>
        )) || (
          <NavLink to="/login" className="navLink">
            LogIn
          </NavLink>
        )}
      </div>
    </nav>
  </header>
)

Nav.propTypes = {
  isAuthenticated: propTypes.bool.isRequired,
  handleLogoutUser: propTypes.func.isRequired,
  authUser: propTypes.instanceOf(Object),
}

export default memo(Nav)
